import { Component, Input } from '@angular/core';
import { ElectionDto } from '@shared/clients/api.generated';
import { SidenavigationLink } from '../sidenavigation/sidenavigation.model';
import { SvgIcon } from '@valg-shared/utils/svg-icon';
import { SidenavigationLinkType } from './page-layout.model';
import { camelToSnakeCase } from '@valg-shared/utils/string-utils';
import { Breadcrumb } from '../breadcrumbs/breadcrumb.model';

@Component({
  selector: 'valg-dk-page-layout',
  templateUrl: './page-layout.component.html'
})
export class PageLayoutComponent {
  
  SvgIcon = SvgIcon;

  @Input() election?: ElectionDto;
  @Input() links: SidenavigationLink[] = [];
  @Input() filterLinks: SidenavigationLink[] = [];
  @Input() sideNavTitleType?: SidenavigationLinkType;
  @Input() parentLinkType?: SidenavigationLinkType;

  private _backLink?: Breadcrumb;
  @Input() set backLink(value: Breadcrumb | undefined) {
    if(value){
      this._backLink = {
        url: value.url,
        type: value.type,
        label: 'breadcrumb.back_to_overview.'+camelToSnakeCase(value.type)
      }
    }
  }

  get sidenavTitle(): string{
    let title = "navigation.go_to_";
    return this.sideNavTitleType ? title+camelToSnakeCase(this.sideNavTitleType) : "";
  }

  get sidenavParentTitle(): string{
    let title = "sidenavigation.titles.";
    return this.parentLinkType ? title+camelToSnakeCase(this.parentLinkType) : "";
  }

  get backLink(): Breadcrumb | undefined {
    return this._backLink ?? undefined;
  }

}
